import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getDependentSummary = createAsyncThunk("insurance-dependent/dependentDetails/111", async (token, type) => {
    try {
        const response = await nodeinstance.get("insurance-dependent/dependentDetails/111", {
            headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response.data.data);
        return response.data.data;
       
    } catch (e) {
        throw new Error(e.message);
    }
});


const dependentSummary = createSlice({
    name: "dependentSummary",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDependentSummary.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getDependentSummary.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getDependentSummary.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getDependentSummary };
export default dependentSummary.reducer;
